<template>
  <base-container>
    <div style="margin-bottom:70px">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" >
        <van-swipe-item v-for="(image, index) in images" :key="index" @click="gotoClick(index)">
          <img :src="image" style="width:100%;height:100%;" />
        </van-swipe-item>
      </van-swipe>
      <van-notice-bar left-icon="volume-o" :text="noticeInfo" />
      <ClassifyCard title="水费">
        <van-grid :column-num="3">
          <van-grid-item to="/waterrecharge">
            <van-image :src="require('@/assets/img/icon-01.png')" />
            <div>水费充值</div>
          </van-grid-item>
          <van-grid-item to="/waterquery">
            <van-image :src="require('@/assets/img/icon-02.png')" />
            <div>水费查询</div>
          </van-grid-item>
          <van-grid-item to="/waterrecord">
            <van-image :src="require('@/assets/img/icon-03.png')" />
            <div>水费充值记录</div>
          </van-grid-item>
        </van-grid>
      </ClassifyCard>
      <ClassifyCard title="医疗">
        <van-grid :column-num="3">
          <van-grid-item to="/hosregisterdept">
            <van-image :src="require('@/assets/img/icon04.png')" />
            <div>当日挂号</div>
          </van-grid-item>
          <van-grid-item to="/hosreservedept">
            <van-image :src="require('@/assets/img/icon05.png')" />
            <div>预约挂号</div>
          </van-grid-item>
          <van-grid-item to="/hosregisterrecord">
            <van-image :src="require('@/assets/img/icon06.png')" />
            <div>挂号记录</div>
          </van-grid-item>
        </van-grid>
      </ClassifyCard>
      <ClassifyCard title="公积金">
        <van-grid :column-num="3">
          <van-grid-item to="/providentquery">
            <van-image :src="require('@/assets/img/icon07.png')" />
            <div>公积金</div>
          </van-grid-item>
        </van-grid>
      </ClassifyCard>
    </div>
  </base-container>
</template>

<script>
  // @ is an alias to /src
  import ClassifyCard from "@/components/ClassifyCard.vue";
  import { Notify } from "vant";
  import {GetNoticeInfo} from "@/api/customer";
  export default {
    name: "Home",
    components: {
      ClassifyCard,
    },
    data() {
      return {
        images: [
          require("@/assets/img/banner01.png"),
          require("@/assets/img/banner02.png"),
          require("@/assets/img/banner03.png"),
        ],
        noticeInfo:"",
      };
    },
    created() {
      this.myBrowser();
      GetNoticeInfo().then(res=>{
        if(res.data.value!=null){
          this.noticeInfo=res.data.value.noticeContent;
        }
      });
    },
    methods: {
      gotoClick(index) {
        if (index == 0) {//预约挂号
          this.toBannerPage("hosreservedept");
        }
        else if (index == 1)//当日挂号
        {
          this.toBannerPage("hosregisterdept");
        }
      },
      toPath(url) {
        this.$router.push(url);
      },
      toBannerPage(name, params) {
        this.$router.push({ name, params });
      },
      myBrowser() {
        var userAgent = navigator.userAgent;
        //alert("1-" + userAgent);
        ////取得浏览器的userAgent字符串
        var isMicromessenger =
          userAgent.toLowerCase().indexOf("micromessenger") > -1;
        var isAplipay = userAgent.toLowerCase().indexOf("aplipay") > -1;
        if (isMicromessenger || isAplipay) {
          Notify({
            type: "warning",
            message: "请在APP内打开",
            duration: 5000,
          });
        }
      },
    },
  };
</script>
<style scoped>

</style>